import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import animations from "themes/foundations/animations";
import { pxToRem } from "themes/utils/mapPxToRem";

interface AccordionProps {
    colorScheme?: string;
}

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    accordionAnatomy.keys
);

const baseStyle = definePartsStyle({
    root: {
        borderTop: "1px solid",
        borderColor: "brand.lightGray",
    },
    icon: {
        minWidth: pxToRem("24px"),
        minHeight: pxToRem("24px"),
    },
});

const brandGray = "brand.whiteSmoke";

const sharedButtonStyles = {
    textAlign: "left",
    gap: ["sp12", null, null, "sp24"],
    alignItems: ["top", null, null, null, "center"],
    fontSize: ["sm", null, null, "xl", null],
    px: "sp24",
    py: "sp32",
    transitionDuration: animations.fast,
};

const variants = {
    ContentAccordion: (props: AccordionProps) => {
        const { colorScheme = brandGray } = props;
        return {
            button: {
                ...sharedButtonStyles,
                _hover: { background: colorScheme },
                _focusVisible: { background: colorScheme },
                _expanded: { background: colorScheme },
            },
            panel: {
                background: colorScheme,
                fontSize: ["xxs", null, null, "sm"],
                px: ["sp60", null, null, "sp216"],
                pb: "sp32",
                pr: [null, null, null, "sp96", "sp96"],
            },
        };
    },

    ContentAccordionWithoutNumbers: (props: AccordionProps) => {
        const { colorScheme = brandGray } = props;
        return {
            button: {
                ...sharedButtonStyles,
                pl: "sp60",
                _hover: { background: colorScheme },
                _focusVisible: { background: colorScheme },
                _expanded: { background: colorScheme },
            },
            panel: {
                background: colorScheme,
                fontSize: ["xxs", null, null, "sm"],
                px: ["sp60"],
                pb: "sp32",
            },
        };
    },

    SessionAccordion: {
        button: {
            ...sharedButtonStyles,
            _hover: { background: brandGray },
            _focusVisible: { background: brandGray },
            _expanded: { background: brandGray },
        },
        panel: {
            background: brandGray,
            fontSize: ["xxs", null, null, "sm"],
            px: "sp24",
            py: "sp32",
        },
    },
};

export default defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {},
});
